import * as MD from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../../Store';
import { I18N } from '../../../Store/I18n/Types';
import { IUserState } from '../../../Store/User/Types';
import {
	getACLRights,
	getACLUserByID,
	getUserRights,
	updateRightsBatch,
} from '../../../Store/UserManagement/Actions';
import { getACLResources } from '../../../Store/ResourcesManagement/Actions';
import {
	ACLRight,
	IUserManagementState, UserRights
} from '../../../Store/UserManagement/Types';
import { IResourcesManagementState } from '../../../Store/ResourcesManagement/Types';
import { ACLResource } from '../../../Store/ResourcesManagement/Types';
import { getTheme } from '../../../Themes';
export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
	resourcesManagement: IResourcesManagementState;
	isLoading: boolean;
}

interface IState {
	userID: number;
	openedRight: number[];
	openedResource: number[];
	addedRights: {
		resourceId: number;
		rightsId: number[];
	}[];
	resourceIDsRightsToBeDeleted: number[];
	resourceIDsRightsToBeUpdated: number[];
	resourceIDsRightsIDsToBeUpdated: {
		usersResourcesID: number;
		rightsId: number[];
	}[];
	reloading: boolean;
}

interface IPropsFromDispatch {
	getACLResources: typeof getACLResources;
	getACLRights: typeof getACLRights;
	getACLUserByID: typeof getACLUserByID;
	getUserRights: typeof getUserRights;
	updateRightsBatch: typeof updateRightsBatch;
}

const theme = getTheme();

const styles = MD.createStyles({
	row: {
		'& > *': {
			borderBottom: 'unset',
		},
		background: '#4E1E64',
	},
	rowDeleted: {
		'& > *': {
			borderBottom: 'unset',
		},
		background: red[900],
	},
	rowParent: {
		'& > *': {
			borderBottom: 'unset',
		},
		background: '#28265B',
	},
	table: {
		minWidth: 750,
	},
	margin: {
		margin: theme.spacing(1),
	},
	noResult: {
		textAlign: 'center',
		fontSize: 'large',
	},
	cell25: {
		width: '25%',
	},
	cell5: {
		width: '5%',
	},
	cell20: {
		width: '20%',
	},
	cell10: {
		width: '10%',
	},
	cell30: {
		width: '30%',
	},
	divleft: {
		width: '80%',
		float: 'left',
	},
	buttonFixed: {
		position: 'fixed',
		marginLeft: '4%',
		width: '10%',
	},
	smallIcon: {
		padding: '3px',
	},
});

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class UserManagementContentRightsListComponent extends React.Component<
	AllProps,
	IState
> {
	private listIDToDisplay: number[];
	private listIDofRightAlreadyAttributedToTheCurentUser: number[];
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			userID: -1,
			openedRight: [],
			openedResource: [],
			addedRights: [],
			resourceIDsRightsToBeDeleted: [],
			resourceIDsRightsToBeUpdated: [],
			resourceIDsRightsIDsToBeUpdated: [],
			reloading: false,
		};
		this.listIDToDisplay = [];
		this.listIDofRightAlreadyAttributedToTheCurentUser = [];
	}

	public componentDidMount() {
		if (this.props.router.match.params.groupName !== undefined) {
			if (this.props.router.match.params.groupName !== 'undefined') {
				this.props.getACLResources(this.props.user.token);
				this.props.getACLRights(this.props.user.token);
				this.props.getUserRights(
					this.props.user.token,
					parseInt(this.props.router.match.params.groupName, 10)
				);

				this.props.getACLUserByID(
					this.props.user.token,
					parseInt(this.props.router.match.params.groupName, 10)
				);
			}
		}
	}

	public render(): React.ReactNode {
		return (
			<React.Fragment>
				{this.props.router.match.params.groupName === undefined
					? this.selectUserID()
					: this.props.router.match.params.groupName === 'undefined'
					? this.selectUserID()
					: this.props.user.groupID === 2
					? this.showRights()
					: this.props.user.groupID ===
					  this.props.userManagement.userToModify.parent.id
					? this.showRights()
					: this.redirection()}
			</React.Fragment>
		);
	}
	private selectUserID(): React.ReactNode {
		return (
			<p>Please select an user before checking the rights attributed</p>
		);
	}

	private redirection(): React.ReactNode {
		return <Redirect to="/" />;
	}

	private showRights(): React.ReactNode {
		this.listIDToDisplay = this.mergeRights();
		const classes = this.props.classes;
		return (
			<div>
				<div className={classes.divleft}>
					<h1>
						User #{this.props.router.match.params.groupName} curent
						rights
					</h1>
					<MD.TableContainer
						component={MD.Paper}
						className={classes.table}
					>
						<MD.Table aria-label="collapsible table" size="small">
							<MD.TableHead>
								<MD.TableRow>
									<MD.TableCell />
									<MD.TableCell>ID</MD.TableCell>
									<MD.TableCell align="left">
										{this.props.i18n._('Resource name')}
									</MD.TableCell>
									<MD.TableCell align="left">
										{this.props.i18n._('Origin')}
									</MD.TableCell>
									<MD.TableCell align="left">
										{this.props.i18n._('Rights')}
									</MD.TableCell>
									<MD.TableCell>
										{this.props.i18n._('Update')}
									</MD.TableCell>
								</MD.TableRow>
							</MD.TableHead>
							{this.displayTableBodyRights()}
						</MD.Table>
					</MD.TableContainer>

					<h1>
						User #{this.props.router.match.params.groupName} rigths
						that can be added
					</h1>

					<MD.TableContainer
						component={MD.Paper}
						className={classes.table}
					>
						<MD.Table aria-label="collapsible table" size="small">
							<MD.TableHead>
								<MD.TableRow>
									<MD.TableCell />
									<MD.TableCell>ID</MD.TableCell>
									<MD.TableCell align="left">
										{this.props.i18n._('Resource name')}
									</MD.TableCell>
									<MD.TableCell align="left">
										{this.props.i18n._('Rights')}
									</MD.TableCell>
								</MD.TableRow>
							</MD.TableHead>
							{this.displayTableBodyResources()}
						</MD.Table>
					</MD.TableContainer>
				</div>
				<MD.Button
					className={classes.buttonFixed}
					color="primary"
					variant="contained"
					onClick={this.onSubmit.bind(this)}
					disabled={this.props.isLoading}
				>
					{this.props.isLoading ? (
						<CircularProgress 
							size={24} 
							color="inherit"
							thickness={4}
							style={{ color: '#fff' }}
						/>
					) : (
						this.props.i18n._('Update')
					)}
				</MD.Button>
			</div>
		);
	}

	private displayTableBodyRights(): React.ReactNode | string {
		const classes = this.props.classes;
		if (this.props.userManagement.rightsCount !== 0) {
			return (
				<MD.TableBody>
					{this.props.userManagement.userRights.map((u, i) =>
						this.generateRowRights(u, i)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={3} className={classes.noResult}>
							No result
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}

	private displayTableBodyResources(): React.ReactNode | string {
		return (
			<MD.TableBody>
				{this.props.resourcesManagement.allACLResources.map((u, i) =>
					this.generateRowResources(u, i)
				)}
			</MD.TableBody>
		);
	}

	private generateRowRights(
		resourceRights: UserRights,
		i: number
	): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment key={i}>
				<MD.TableRow
					className={
						this.state.resourceIDsRightsToBeDeleted.includes(
							resourceRights.id
						)
							? classes.rowDeleted
							: resourceRights.origin === 'user'
							? classes.row
							: classes.rowParent
					}
				>
					<MD.TableCell className={classes.cell5}>
						{resourceRights.resource.children.length !== 0 ? (
							<MD.IconButton
								aria-label="expand row"
								size="small"
								onClick={() => {
									if (
										this.state.openedRight.includes(
											resourceRights.id
										)
									) {
										this.onRemoveItemRights(
											resourceRights.id
										);
									} else {
										this.onAddItemRights(resourceRights.id);
									}
								}}
							>
								{this.state.openedRight.includes(
									resourceRights.id
								) ? (
									<KeyboardArrowUpIcon />
								) : (
									<KeyboardArrowDownIcon />
								)}
							</MD.IconButton>
						) : (
							''
						)}
					</MD.TableCell>
					<MD.TableCell
						className={classes.cell5}
						component="th"
						scope="row"
					>
						{resourceRights.id}
					</MD.TableCell>
					<MD.TableCell className={classes.cell30} align="left">
						{resourceRights.resource.name}
					</MD.TableCell>
					<MD.TableCell className={classes.cell10} align="left">
						{resourceRights.origin}
					</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Table>
							<MD.TableBody>
								<MD.TableRow
									className={
										this.state.resourceIDsRightsToBeDeleted.includes(
											resourceRights.id
										)
											? classes.rowDeleted
											: resourceRights.origin === 'user'
											? classes.row
											: classes.rowParent
									}
								>
									{this.state.resourceIDsRightsToBeUpdated.includes(
										resourceRights.id
									)
										? this.resourceRightsRightsUpdated(
												resourceRights
										  )
										: this.resourceRightsRightsDisplay(
												resourceRights
										  )}
								</MD.TableRow>
							</MD.TableBody>
						</MD.Table>
					</MD.TableCell>
					<MD.TableCell>
						{resourceRights.origin === 'user' ? (
							<React.Fragment>
								<IconButton
									className={classes.smallIcon}
									color="primary"
									aria-label="edit picture"
									component="span"
									onClick={(
										event: React.MouseEvent<
											HTMLButtonElement,
											MouseEvent
										>
									) => {
										if (
											this.state.resourceIDsRightsToBeUpdated.includes(
												resourceRights.id
											)
										) {
											this.onRemoveResourcesToBeUpdated(
												resourceRights.id
											);
										} else {
											this.onAddResourcesToBeUpdated(
												resourceRights
											);
										}
									}}
								>
									<EditIcon />
								</IconButton>
								<IconButton
									className={classes.smallIcon}
									color="primary"
									aria-label="edit picture"
									component="span"
									onClick={(
										event: React.MouseEvent<
											HTMLButtonElement,
											MouseEvent
										>
									) => {
										if (
											this.state.resourceIDsRightsToBeDeleted.includes(
												resourceRights.id
											)
										) {
											this.onRemoveRightsToBeDeleted(
												resourceRights.id
											);
										} else {
											this.onAddRightsToBeDeleted(
												resourceRights.id
											);
										}
									}}
								>
									<DeleteIcon style={{ color: red[500] }} />
								</IconButton>
							</React.Fragment>
						) : (
							''
						)}
					</MD.TableCell>
				</MD.TableRow>
				<MD.TableRow>
					<MD.TableCell
						style={{ paddingBottom: 0, paddingTop: 0 }}
						colSpan={7}
					>
						<MD.Collapse
							in={this.state.openedRight.includes(
								resourceRights.id
							)}
							timeout="auto"
							unmountOnExit
						>
							<MD.Box margin={1}>
								<MD.Table size="small" aria-label="children">
									<MD.TableHead>
										<MD.TableRow>
											<MD.TableCell />
											<MD.TableCell>ID</MD.TableCell>
											<MD.TableCell align="left">
												{this.props.i18n._(
													'Resource name'
												)}
											</MD.TableCell>

											<MD.TableCell align="left">
												{this.props.i18n._('Origin')}
											</MD.TableCell>
											<MD.TableCell align="left">
												{this.props.i18n._('Rights')}
											</MD.TableCell>
											<MD.TableCell>
												{this.props.i18n._('Update')}
											</MD.TableCell>
										</MD.TableRow>
									</MD.TableHead>
									<MD.TableBody>
										{resourceRights.resource.children.map(
											(u, i) =>
												this.generateRowRights(u, i)
										)}
									</MD.TableBody>
								</MD.Table>
							</MD.Box>
						</MD.Collapse>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private resourceRightsRightsUpdated(
		resourceRights: UserRights
	): React.ReactNode {
		const classes = this.props.classes;

		const items: JSX.Element[] = [
			<MD.TableCell
				key={0}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,

			<MD.TableCell
				key={1}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,

			<MD.TableCell
				key={2}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,

			<MD.TableCell
				key={3}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,
		];
		this.props.userManagement.ACLRights.forEach(
			(value: ACLRight, index: number, array: ACLRight[]) => {
				items[value.id - 1] = (
					<MD.TableCell
						key={value.id - 1}
						className={classes.cell25}
						align="left"
					>
						<MD.Checkbox
							defaultChecked={this.defaultChecked(
								index,
								resourceRights
							)}
							onChange={(
								event: React.ChangeEvent<HTMLInputElement>,
								checked: boolean
							) => {
								checked
									? this.onAddResourcesRightsToBeUpdated(
											resourceRights.id,
											index + 1
									  )
									: this.onRemoveResourcesRightsToBeUpdated(
											resourceRights.id,
											index + 1
									  );
							}}
						/>
						{value.name}
					</MD.TableCell>
				);
			}
		);
		return <React.Fragment>{items}</React.Fragment>;
	}

	private defaultChecked(i: number, resourceRights: UserRights): boolean {
		let defaultChecked: boolean = false;

		for (let j: number = 0; j < resourceRights.rights.length; j++) {
			if (resourceRights.rights[j].id === i + 1) {
				defaultChecked = true;
				break;
			}
		}
		return defaultChecked;
	}

	private resourceRightsRightsDisplay(
		resourceRights: UserRights
	): React.ReactNode {
		const classes = this.props.classes;

		const items: JSX.Element[] = [
			<MD.TableCell
				key={0}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,

			<MD.TableCell
				key={1}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,

			<MD.TableCell
				key={2}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,

			<MD.TableCell
				key={3}
				className={classes.cell25}
				align="left"
			></MD.TableCell>,
		];
		let i: number;

		for (i = 0; i < resourceRights.rights.length; i++) {
			items[resourceRights.rights[i].id - 1] = (
				<MD.TableCell
					key={resourceRights.rights[i].id - 1}
					className={classes.cell25}
					align="left"
				>
					{resourceRights.rights[i].name}
				</MD.TableCell>
			);
		}
		return <React.Fragment>{items}</React.Fragment>;
	}

	private generateRowResources(
		resource: ACLResource,
		i: number
	): React.ReactNode {
		const classes = this.props.classes;
		if (resource.parent !== null) {
			return;
		}
		if (!this.listIDToDisplay.includes(resource.id)) {
			return;
		}
		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell className={classes.cell5}>
						{resource.children.length !== 0 ? (
							<MD.IconButton
								aria-label="expand row"
								size="small"
								onClick={() => {
									if (
										this.state.openedResource.includes(
											resource.id
										)
									) {
										this.onRemoveItemResources(resource.id);
									} else {
										this.onAddItemResources(resource.id);
									}
								}}
							>
								{this.state.openedResource.includes(
									resource.id
								) ? (
									<KeyboardArrowUpIcon />
								) : (
									<KeyboardArrowDownIcon />
								)}
							</MD.IconButton>
						) : (
							''
						)}
					</MD.TableCell>
					<MD.TableCell
						className={classes.cell5}
						component="th"
						scope="row"
					>
						{resource.id}
					</MD.TableCell>
					<MD.TableCell className={classes.cell30} align="left">
						{resource.name}
					</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Table>
							<MD.TableBody>
								<MD.TableRow className={classes.row}>
									{this.props.userManagement.ACLRights[0] !==
									undefined ? (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										>
											<MD.Checkbox
												disabled={this.listIDofRightAlreadyAttributedToTheCurentUser.includes(
													resource.id
												)}
												onChange={(
													event: React.ChangeEvent<HTMLInputElement>,
													checked: boolean
												) => {
													checked
														? this.onAddRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[0]
																	.id
														  )
														: this.onRemoveRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[0]
																	.id
														  );
												}}
											/>
											{
												this.props.userManagement
													.ACLRights[0].name
											}
										</MD.TableCell>
									) : (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										></MD.TableCell>
									)}
									{this.props.userManagement.ACLRights[1] !==
									undefined ? (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										>
											<MD.Checkbox
												disabled={this.listIDofRightAlreadyAttributedToTheCurentUser.includes(
													resource.id
												)}
												onChange={(
													event: React.ChangeEvent<HTMLInputElement>,
													checked: boolean
												) => {
													checked
														? this.onAddRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[1]
																	.id
														  )
														: this.onRemoveRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[1]
																	.id
														  );
												}}
											/>
											{
												this.props.userManagement
													.ACLRights[1].name
											}
										</MD.TableCell>
									) : (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										></MD.TableCell>
									)}
									{this.props.userManagement.ACLRights[2] !==
									undefined ? (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										>
											<MD.Checkbox
												disabled={this.listIDofRightAlreadyAttributedToTheCurentUser.includes(
													resource.id
												)}
												onChange={(
													event: React.ChangeEvent<HTMLInputElement>,
													checked: boolean
												) => {
													checked
														? this.onAddRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[2]
																	.id
														  )
														: this.onRemoveRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[2]
																	.id
														  );
												}}
											/>
											{
												this.props.userManagement
													.ACLRights[2].name
											}
										</MD.TableCell>
									) : (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										></MD.TableCell>
									)}
									{this.props.userManagement.ACLRights[3] !==
									undefined ? (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										>
											<MD.Checkbox
												disabled={this.listIDofRightAlreadyAttributedToTheCurentUser.includes(
													resource.id
												)}
												onChange={(
													event: React.ChangeEvent<HTMLInputElement>,
													checked: boolean
												) => {
													checked
														? this.onAddRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[3]
																	.id
														  )
														: this.onRemoveRights(
																resource.id,
																this.props
																	.userManagement
																	.ACLRights[3]
																	.id
														  );
												}}
											/>
											{
												this.props.userManagement
													.ACLRights[3].name
											}
										</MD.TableCell>
									) : (
										<MD.TableCell
											className={classes.cell25}
											align="left"
										></MD.TableCell>
									)}
								</MD.TableRow>
							</MD.TableBody>
						</MD.Table>
					</MD.TableCell>
				</MD.TableRow>
				<MD.TableRow>
					<MD.TableCell
						style={{ paddingBottom: 0, paddingTop: 0 }}
						colSpan={7}
					>
						<MD.Collapse
							in={this.state.openedResource.includes(resource.id)}
							timeout="auto"
							unmountOnExit
						>
							<MD.Box margin={1}>
								<MD.Table size="small" aria-label="children">
									<MD.TableHead>
										<MD.TableRow>
											<MD.TableCell />
											<MD.TableCell>ID</MD.TableCell>
											<MD.TableCell align="left">
												{this.props.i18n._(
													'Resource name'
												)}
											</MD.TableCell>
											<MD.TableCell align="left">
												{this.props.i18n._('Rights')}
											</MD.TableCell>
										</MD.TableRow>
									</MD.TableHead>
									<MD.TableBody>
										{resource.children.map((u, i) =>
											this.generateRowResources(u, i)
										)}
									</MD.TableBody>
								</MD.Table>
							</MD.Box>
						</MD.Collapse>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private onRemoveItemRights(itemToRemove: number) {
		const list = this.state.openedRight;
		const listUpdated = list.filter((item) => item !== itemToRemove);
		this.setState({ openedRight: listUpdated });
	}

	private onAddItemRights(itemToAdd: number) {
		const list = this.state.openedRight;
		list.push(itemToAdd);
		this.setState({ openedRight: list });
	}

	private onRemoveRightsToBeDeleted(itemToRemove: number) {
		const list = this.state.resourceIDsRightsToBeDeleted;
		const listUpdated = list.filter((item) => item !== itemToRemove);
		this.setState({ resourceIDsRightsToBeDeleted: listUpdated });
	}

	private onAddRightsToBeDeleted(itemToAdd: number) {
		const list = this.state.resourceIDsRightsToBeDeleted;
		list.push(itemToAdd);
		this.setState({ resourceIDsRightsToBeDeleted: list });
	}

	private onRemoveResourcesToBeUpdated(itemToRemove: number) {
		const list = this.state.resourceIDsRightsToBeUpdated;
		const listUpdated = list.filter((item) => item !== itemToRemove);
		this.setState({ resourceIDsRightsToBeUpdated: listUpdated });
	}

	private onAddResourcesToBeUpdated(resourceRights: UserRights) {
		const list = this.state.resourceIDsRightsToBeUpdated;
		list.push(resourceRights.id);
		this.setState({ resourceIDsRightsToBeUpdated: list });
		resourceRights.rights.forEach((right) => {
			this.onAddResourcesRightsToBeUpdated(resourceRights.id, right.id);
		});
	}

	private onAddResourcesRightsToBeUpdated(
		resourceId: number,
		rightId: number
	) {
		const list = this.state.resourceIDsRightsIDsToBeUpdated;
		var wasAdded = false;
		list.forEach((item) => {
			if (item.usersResourcesID === resourceId) {
				item.rightsId.push(rightId);
				wasAdded = true;
			}
		});
		if (!wasAdded) {
			list.push({ usersResourcesID: resourceId, rightsId: [rightId] });
		}
		this.setState({ resourceIDsRightsIDsToBeUpdated: list });
	}

	private onRemoveResourcesRightsToBeUpdated(
		resourceId: number,
		rightId: number
	) {
		const list = this.state.resourceIDsRightsIDsToBeUpdated;
		const newList: {
			usersResourcesID: number;
			rightsId: number[];
		}[] = [];
		list.forEach((resource) => {
			if (resource.usersResourcesID === resourceId) {
				resource.rightsId = resource.rightsId.filter(
					(right) => right !== rightId
				);
				if (resource.rightsId.length !== 0) {
					newList.push(resource);
				}
			} else {
				newList.push(resource);
			}
		});
		this.setState({ resourceIDsRightsIDsToBeUpdated: newList });
	}

	private onRemoveItemResources(itemToRemove: number) {
		const list = this.state.openedResource;
		const listUpdated = list.filter((item) => item !== itemToRemove);
		this.setState({ openedResource: listUpdated });
	}

	private onAddItemResources(itemToAdd: number) {
		const list = this.state.openedResource;
		list.push(itemToAdd);
		this.setState({ openedResource: list });
	}

	private onAddRights(resourceId: number, rightId: number) {
		const list = this.state.addedRights;
		var wasAdded = false;
		list.forEach((item) => {
			if (item.resourceId === resourceId) {
				item.rightsId.push(rightId);
				wasAdded = true;
			}
		});
		if (!wasAdded) {
			list.push({ resourceId, rightsId: [rightId] });
		}
		this.setState({ addedRights: list });
	}

	private onRemoveRights(resourceId: number, rightId: number) {
		const list = this.state.addedRights;
		const newList: {
			resourceId: number;
			rightsId: number[];
		}[] = [];
		list.forEach((resource) => {
			if (resource.resourceId === resourceId) {
				resource.rightsId = resource.rightsId.filter(
					(right) => right !== rightId
				);
				if (resource.rightsId.length !== 0) {
					newList.push(resource);
				}
			} else {
				newList.push(resource);
			}
		});
		this.setState({ addedRights: newList });
	}

	private mergeRights(): number[] {
		let listResourceID: number[];
		listResourceID = [];
		this.props.resourcesManagement.allACLResources.forEach((element) => {
			listResourceID.push(element.id);
		});
		this.listIDofRightAlreadyAttributedToTheCurentUser =
			this.getAllRightsID(this.props.userManagement.userRights);
		const list = this.listIDofRightAlreadyAttributedToTheCurentUser;
		var intersection = listResourceID.filter(function (e) {
			return list.indexOf(e) === -1;
		});

		intersection.forEach((id) => {
			this.props.resourcesManagement.allACLResources.forEach((item) => {
				if (item.id === id) {
					intersection.push.apply(
						intersection,
						this.checkAllParent(item)
					);
				}
			});
		});

		return intersection;
	}

	private checkAllParent(checkedResource: ACLResource): number[] {
		var arraytoreturn: number[] = [];
		if (checkedResource.parent !== null) {
			arraytoreturn.push(checkedResource.parent.id);
			this.props.resourcesManagement.allACLResources.forEach((item) => {
				if (item.id === checkedResource.parent.id) {
					arraytoreturn.push.apply(
						arraytoreturn,
						this.checkAllParent(item)
					);
				}
			});
		}
		return arraytoreturn;
	}

	private getAllRightsID(userRights: UserRights[]): number[] {
		let listRightsID: number[];
		listRightsID = [];

		userRights.forEach((element) => {
			listRightsID.push(element.resource.id);
			element.resource.children.forEach((element) => {
				let listChildrenID: number[];
				listChildrenID = [];
				listRightsID.push(element.resource.id);
				listChildrenID = this.getAllRightsID(element.resource.children);
				listRightsID.push.apply(listRightsID, listChildrenID);
			});
		});
		return listRightsID;
	}

	private onSubmit() {
		this.props.updateRightsBatch(
			this.props.user.token,
			parseInt(this.props.router.match.params.groupName, 10),
			this.state.addedRights,
			this.state.resourceIDsRightsToBeDeleted,
			this.state.resourceIDsRightsIDsToBeUpdated
		);

		// Réinitialiser le state local après avoir dispatché l'action
		this.setState({
			addedRights: [],
			resourceIDsRightsToBeDeleted: [],
			resourceIDsRightsToBeUpdated: [],
			resourceIDsRightsIDsToBeUpdated: []
		});
	}
}

const mapStateToProps = (
	{ i18n, user, userManagement, resourcesManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	router: ownProps,
	i18n: i18n.i18n,
	user,
	userManagement,
	resourcesManagement,
	isLoading: userManagement.isRightsLoading,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLResources: (token: string) => dispatch(getACLResources(token)),
	getACLRights: (token: string) => dispatch(getACLRights(token)),
	getACLUserByID: (token: string, params: number) =>
		dispatch(getACLUserByID(token, params)),
	getUserRights: (token: string, id: number) =>
		dispatch(getUserRights(token, id)),
	updateRightsBatch: (
		token: string,
		userId: number,
		addedRights: { resourceId: number; rightsId: number[] }[],
		resourceIDsRightsToBeDeleted: number[],
		resourceIDsRightsToBeUpdated: { usersResourcesID: number; rightsId: number[] }[]
	) => dispatch(updateRightsBatch(token, userId, addedRights, resourceIDsRightsToBeDeleted, resourceIDsRightsToBeUpdated)),
});

export const UserManagementContentRightsList = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(UserManagementContentRightsListComponent));
